// views/Settings/vendorSettingsGroup.js
// ─────────────────────────────────────────────────────────────────────────────
// The SETTINGS group for a vendor or 3PL partner sidebar (phase 2, 31 Oct
// 2026). One factory, called once per vertical in routes.js with that
// vertical's own profile and outlet screens, so the group reads the same for
// a restaurant, a retailer, a pharmacy, a brand and a partner:
//
//   Business profile   the vertical's profile screen (hours, contact, fulfilment,
//                      minimum order, delivery coverage)
//   Alerts             order alerts by email, SMS and WhatsApp, and this
//                      person's own sound and desktop preferences
//   Tax                the vendor's own VAT and EFRIS position
//   Team & roles       who may act for the business
//   Outlets            where the business has branches (brands today)
//   Auto-assign        3PL dispatch radius, retries and cooldown
//
// Gating is per entry, through the vendor team permissions layouts/Admin.js
// already applies (`vendorPermission`, `wholeBusinessOnly`). The old Account
// and My Team groups are gone; their paths redirect here.
// ─────────────────────────────────────────────────────────────────────────────
import VendorStaffView from "../Vendor/VendorStaffView";
import VendorAlertsSettingsPage from "./VendorAlertsSettingsPage";
import VendorTaxSettingsPage from "./VendorTaxSettingsPage";

export const VENDOR_SETTINGS_BASE = "/admin/settings";

export const vendorSettingsGroup = ({ profile, outlets = null, autoAssign = null, extras = [], state = "openVendorSettings" }) => ({
  collapse: true,
  path: "/settings",
  name: "SETTINGS",
  state,
  icon: "nc-icon nc-settings-gear-64",
  iconColor: "#9fd3ff", // settings sky, same as the staff group
  views: [
    ...(profile ? [{
      path: "/settings/profile",
      layout: "/admin",
      name: "Business profile",
      mini: "BP",
      component: profile,
      vendorPermission: "settings:edit",
      wholeBusinessOnly: true,
    }] : []),
    {
      path: "/settings/alerts",
      layout: "/admin",
      name: "Alerts",
      mini: "AL",
      component: VendorAlertsSettingsPage,
      vendorPermission: "settings:edit",
    },
    ...(profile ? [{
      path: "/settings/tax",
      layout: "/admin",
      name: "Tax",
      mini: "TX",
      component: VendorTaxSettingsPage,
      vendorPermission: "settings:edit",
      wholeBusinessOnly: true,
    }] : []),
    {
      path: "/settings/team",
      layout: "/admin",
      name: "Team & roles",
      mini: "TR",
      component: VendorStaffView,
      vendorPermission: "team:manage",
      wholeBusinessOnly: true,
    },
    ...(outlets ? [{
      path: "/settings/outlets",
      layout: "/admin",
      name: "Outlets",
      mini: "OL",
      component: outlets,
      vendorPermission: "catalogue:view",
    }] : []),
    ...(autoAssign ? [{
      path: "/settings/auto-assign",
      layout: "/admin",
      name: "Auto-assign",
      mini: "AA",
      component: autoAssign,
    }] : []),
    // Views one vertical has and the others do not (a partner's company
    // profile and security), passed in ready-made with their own gates.
    ...extras,
  ],
});

export default vendorSettingsGroup;
